import NotePanel, { Props } from "../NotePanel/NotePanelBase/NotePanel";

type AddProps = Omit<Props, "mode">;

export default function AddNotePanel(props: AddProps) {
  return <NotePanel mode="create" {...props} />;
}
